'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pathsManifest = require('./pathsManifest');

var _pathsManifest2 = _interopRequireDefault(_pathsManifest);

var _redirectTracker = require('./redirectTracker');

var _redirectTracker2 = _interopRequireDefault(_redirectTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
*   parse api responses for 401 and 403 status codes. redirect to appropriate brand login urls if not authorized
*   only needs to happen on client-side api requests
*/

function isWindowDefined() {
    return typeof window !== 'undefined';
}

function getDefaultRedirect(brand, pathAfterSignIn, loggedInWithWeakAuth) {
    var pathname = '';
    var search = '';

    if (pathAfterSignIn) {
        pathname = pathAfterSignIn;
    } else if (isWindowDefined()) {
        pathname = window.location.pathname;
        search = window.location.search;
    }

    return loggedInWithWeakAuth ? _pathsManifest2.default[brand].passwordResetPage(pathname, search) : _pathsManifest2.default[brand].signInPage(pathname, search);
}

function checkApiAuthorization(_ref) {
    var res = _ref.res,
        brand = _ref.brand,
        pathAfterSignIn = _ref.pathAfterSignIn;

    if (isWindowDefined()) {
        if (!brand) {
            // need either a redirect url or the brand to determine where to redirect
            return res;
        }

        // no access to this page, redirect
        if (res.status === 401 || res.status === 403) {
            var loggedInWithWeakAuth = res.data && res.data.error && res.data.error.data && res.data.error.data.loggedIn && res.data.error.data.hasStrongAuthentication === false;
            var redirectLocation = getDefaultRedirect(brand, pathAfterSignIn, loggedInWithWeakAuth);

            var responseData = res.data ? res.data : {};
            var responseErrorData = responseData.error && responseData.error.data ? responseData.error.data : {};
            var userToken = responseErrorData.userToken,
                loggedIn = responseErrorData.loggedIn,
                email = responseErrorData.email,
                hasStrongAuthentication = responseErrorData.hasStrongAuthentication;

            (0, _redirectTracker2.default)({
                userToken: userToken,
                loggedIn: loggedIn,
                email: email,
                hasStrongAuthentication: hasStrongAuthentication,
                redirectTo: redirectLocation
            });
            try {
                window.stop();
            } catch (exception) {
                document.execCommand('Stop');
            }
            window.location.replace(redirectLocation);

            return true;
        }

        return res;
    } else {
        // a sever side request
        return res;
    }
}

exports.default = checkApiAuthorization;